import ReportsTravelRule from './ReportsTravelRule'

export default ReportsTravelRule
